import {
  authenticatedApi,
  ApiError,
  API_BASE_URL,
} from './apiUtils';

export const importApi = {
  validateEmployees: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/employees/import/validate`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to validate employee data', 400);
      }
      throw new ApiError('Failed to validate employee data', error.status || 500);
    }
  },

  importEmployees: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/employees/import`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to import employee data', 400);
      }
      throw new ApiError('Failed to import employee data', error.status || 500);
    }
  },

  validateProjects: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/projects/import/validate`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to validate project data', 400);
      }
      throw new ApiError('Failed to validate project data', error.status || 500);
    }
  },

  importProjects: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/projects/import`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to import project data', 400);
      }
      throw new ApiError('Failed to import project data', error.status || 500);
    }
  },

  validateEmployeeToProject: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/employee-projects/import/validate`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to validate employee to project data', 400);
      }
      throw new ApiError('Failed to validate employee to project data', error.status || 500);
    }
  },

  importEmployeeToProject: async (rows) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/employee-projects/import`, { rows });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Failed to import employee to project data', 400);
      }
      throw new ApiError('Failed to import employee to project data', error.status || 500);
    }
  },
};